import React from "react";
import {
  WSElement,
  WSElementProps,
  WSElementSpacingsType
} from "../WSElement/WSElement.component";
import styles from "./WSCollapsible.module.scss";
import { WSIcon, WSIconName, WSText } from "../core";
import { WSFlexBox } from "../layout/WSFlexBox/WSFlexBox.component";

export const DEFAULT_COLLAPSIBLE_SIZE: WSCollapsibleSize = "M";

export type WSCollapsibleSize = "S" | "M";

export type WSCollapsibleProps = WSElementProps & {
  title: string | React.ReactNode;
  size?: WSCollapsibleSize;
  icon?: WSIconName;
};

const mapPadding: Record<WSCollapsibleSize, WSElementSpacingsType> = {
  S: "M",
  M: "XL"
};

export const WSCollapsible: React.FC<WSCollapsibleProps> = ({
  title,
  className,
  children,
  icon,
  size = DEFAULT_COLLAPSIBLE_SIZE,
  ...elementProps
}) => {
  return (
    <WSElement as="details" className={styles.collapsible} {...elementProps}>
      <WSElement as="summary" className={styles.summary} p={mapPadding[size]}>
        <WSFlexBox.CenterY justify="space-between">
          <WSFlexBox.CenterY gap="S">
            {icon ? (
              <WSIcon
                name={icon}
                size={size}
                className={styles.icon}
                color="gray600"
              />
            ) : null}
            <WSText.ParagraphSm color="gray600" className={styles.title}>
              {title}
            </WSText.ParagraphSm>
          </WSFlexBox.CenterY>

          <WSIcon
            color="gray500"
            name="caret-down"
            size={size}
            className={styles.caret}
          />
        </WSFlexBox.CenterY>
      </WSElement>
      <WSElement p={mapPadding[size]} className={styles.content}>
        {children}
      </WSElement>
    </WSElement>
  );
};
